module.exports = require("text-encoding");